import AutoTagAPI from "../../../../src/pages/apis/electronic-seal-api/e-seal-key-feature.md";
import BenefitsOfEsealAPITitle from "../../../../src/pages/apis/electronic-seal-api/benefits-of-e-seal-api-title.md";
import BenefitsOfEsealAPIContent from "../../../../src/pages/apis/electronic-seal-api/benefits-of-e-seal-api-contents.md";
import { NewsLetterBlade } from "../../../../src/components/news-letter-blade";
import ExplorUsecase from "../../../../src/pages/apis/electronic-seal-api/explore-use-case.md";
import SealAPIStepper from "../../../../src/pages/apis/electronic-seal-api/seal-api-stepper.md";
import SealAPIAdobeDoc from "../../../../src/pages/apis/electronic-seal-api/seal-api-adobe-doc.md";
import * as React from 'react';
export default {
  AutoTagAPI,
  BenefitsOfEsealAPITitle,
  BenefitsOfEsealAPIContent,
  NewsLetterBlade,
  ExplorUsecase,
  SealAPIStepper,
  SealAPIAdobeDoc,
  React
};